export const getBarWidthPercentage = (
  value: number,
  positiveLimit: number,
  negativeLimitMagnitude: number,
): number => {
  if (value < 0) {
    if (negativeLimitMagnitude <= 0) {
      return 0;
    }

    return Math.min((Math.abs(value) / negativeLimitMagnitude) * 100, 100);
  }

  if (positiveLimit <= 0) {
    return 0;
  }

  return Math.min((value / positiveLimit) * 100, 100);
};

export const getBarWidth = (
  percentage: number,
  shouldStartFromMiddle: boolean,
): string => {
  if (shouldStartFromMiddle) {
    return `${percentage / 2}%`;
  }

  return `${percentage}%`;
};

export const getBarDirection = (value: number): "left" | "right" =>
  value < 0 ? "right" : "left";

export const getBarOffset = (shouldStartFromMiddle: boolean): string | number =>
  shouldStartFromMiddle ? "50%" : 0;
